import * as firebase from 'firebase'

export default {
  state: {
    loadedIndications: [
      {
        indicationId: 'tri',
        indicationName: 'Indication Sample'
      }
    ]
  },
  mutations: {
    setLoadedIndications (state, payload) {
      state.loadedIndications = payload
    },
    createIndication (state, payload) {
      state.loadedIndications.push(payload)
    },
    updateIndication (state, payload) {
      const indication = state.loadedIndications.find(indication => {
        return indication.indicationId === payload.indicationId
      })
      if (payload.indicationName) {
        indication.indicationName = payload.indicationName
      }
    },
    deleteIndication (state, payload) {
      const indication = state.loadedIndications.find(function (indication) {
        return indication.indicationId === payload.indicationId
      })
      var todos = state.loadedIndications
      todos.splice(todos.indexOf(indication), 1)
    }
  },
  actions: {
    loadIndications ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('indications').once('value')
        .then((data) => {
          const indications = []
          const obj = data.val()
          for (let key in obj) {
            indications.push({
              indicationId: key,
              indicationName: obj[key].indicationName,
              creatorId: obj[key].creatorId
            })
          }
          console.log(indications)
          commit('setLoadedIndications', indications)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createIndication ({commit, getters}, payload) {
      const indication = {
        indicationName: payload.title,
        // indicationId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'indication_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('indications').push(indication)
        .then(() => {
          commit('createIndication', {
            ...indication
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createIndication', indication)
    },
    // May have to create a separate Action for each updated item (i.e. updateIndicationIndication, updateIndicationDescription, etc)
    updateIndicationData ({commit}, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.indicationName) {
        updateObj.indicationName = payload.indicationName
      }
      firebase.database().ref('indications').child(payload.indicationId).update(updateObj)
      .then(() => {
        commit('setLoading', false)
        commit('updateIndication', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    },
    deleteIndicationData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('indications').child(payload.indicationId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteIndication', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedIndications (state) {
      return state.loadedIndications.sort((indicationA, indicationB) => {
        return indicationA.date > indicationB.date
      })
    },
    featuredIndications (state, getters) {
      return getters.loadedIndications.slice(0, 5)
    },
    loadedIndication (state) {
      return (someId) => {
        return state.loadedIndications.find((indication) => {
          return indication.indicationId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/indication/index.js